import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNumberOnly]',
    standalone :false
})
export class NumberOnlyDirective {

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        // Allow only digits 0-9, decimal, comma, and negative sign
        if (!/^[0-9]$/.test(event.key)) {
            console.log('Prevented key press:', event.key);
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        // Get pasted content
        const clipboardData = event.clipboardData?.getData('text') || '';

        // Prevent pasting non-numeric or zero values
        if (!/^[0-9]+$/.test(clipboardData)) {
            console.log('Prevented paste:', clipboardData);
            event.preventDefault();
        }
    }
}
